import * as React from 'react'

import cn from '@/utils/tailwind/cn'

import Automations from './Automations'
import { CustomFieldsTab } from './CustomFields/CustomFields'
import { IntegrationsTab } from './IntegrationsTab'
import { SettingsTab } from './SettingsTab'
import TabletsTab from './TabletsTab'

function SettingsContentFC({ selectedTab }) {
  const renderSelectedTab = React.useCallback(() => {
    switch (selectedTab) {
      case 'settings':
        return <SettingsTab />
      case 'automations':
        return <Automations />
      case 'tablets':
        return <TabletsTab />
      case 'integrations':
        return <IntegrationsTab />
      case 'custom-fields':
        return <CustomFieldsTab />
      default:
        return 'Tab not implemented'
    }
  }, [selectedTab])

  return (
    <div
      className={cn({
        'rounded border': !['integrations', 'form-appearance'].includes(
          selectedTab
        ),
      })}
    >
      {renderSelectedTab()}
    </div>
  )
}

function areEqual(a, b) {
  return a?.selectedTab === b?.selectedTab
}

const SettingsContent = React.memo(SettingsContentFC, areEqual)

export default SettingsContent
